export const setDocumentTitle = function (title) {
  document.title = title
  const ua = navigator.userAgent
  // eslint-disable-next-line
  const regex = /\bMicroMessenger\/([\d\.]+)/
  if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    const i = document.createElement('iframe')
    i.src = '/favicon.ico'
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
}
export const changePosition = function (id1, id2) {
  var insert = function (nodeInsert, nodeTo) {
    if (nodeInsert.insertAdjacentElement) {
      nodeTo.insertAdjacentElement('beforeBegin', nodeInsert)
    } else {
      nodeTo.parentNode.insertBefore(nodeInsert, nodeTo)
    }
  }
  var obj = document.createElement('a')
  var t1 = document.getElementById(id1)
  var t2 = document.getElementById(id2)
  insert(obj, t2)
  insert(t2, t1)
  insert(t1, obj)
}
export const loadJs = function (src, callback) {
  const myScript = document.createElement('script')
  myScript.setAttribute('src', src)
  document.body.appendChild(myScript)
  if (callback) {
    myScript.onload = callback
  }
}

export const domTitle = process.env.VUE_APP_TITLE
